module.exports = __webpack_public_path__ + "img/taekwondo3.b9d4bd09.jpg";